function listenerForAtcAndWichlist(){

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.swym-button.swym-add-to-wishlist-view-product');
    if (!button) return;

    if (button.classList.contains('swym-added')) return;

    const container = button.closest('.product-card-wrapper') || button.closest('product-info') || button.closest('.cart-item');
    const gtmPayloadInput = container?.querySelector('.gtmPayload');
    if (!gtmPayloadInput) return;

    let gtmPayload = JSON.parse(gtmPayloadInput.value);
    gtmPayload.event = 'add_to_wishlist';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }, true);

  document.addEventListener('click', function(e) {
    const button = e.target.closest('.addCartCstm');
    if (!button) return;

    const gtmPayloadInput = button.closest('.product-card-wrapper')?.querySelector('.gtmPayload');
    if (!gtmPayloadInput) return;

    let gtmPayload = JSON.parse(gtmPayloadInput.value);
    gtmPayload.event = 'add_to_cart';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  });
}
window.listenerForAtcAndWichlist = listenerForAtcAndWichlist

function viewItemEvent(el) {
  if (!document.body.classList.contains('product')) return;

  let productWrapper = el.closest('.product__info-wrapper');
  if (!productWrapper) return;

  let gtmPayload = productWrapper.querySelector('.gtmPayload').value;

  gtmPayload = JSON.parse(gtmPayload);

  gtmPayload.event = 'view_item';

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(gtmPayload);
}
window.viewItemEvent = viewItemEvent

function addToCartEvent(){
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('[data-type="add-to-cart-form"]');
    if (!form) return;

    const container = form.closest('.product__info-wrapper') || form.closest('.product-card-wrapper');
    const gtmPayloadInput = container?.querySelector('.gtmPayload');
    if (!gtmPayloadInput) return;

    let gtmPayload = JSON.parse(gtmPayloadInput.value);
    gtmPayload.event = 'add_to_cart';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  })
}
document.addEventListener("DOMContentLoaded", (event) => {
  listenerForAtcAndWichlist();
  addToCartEvent();

  document.addEventListener('click', (e) => {
    const aEL = e.target.closest('a.product-link-main');
    if (!aEL) return;

    const cardWrapper = aEL.closest('.product-card-wrapper');
    if (!cardWrapper) return;

    e.preventDefault();
    let redirectURL = aEL.href;
    try {
      let rawPayload = JSON.parse(cardWrapper.querySelector('.gtmPayload').value);
      let deblicatePayload = Object.assign({}, rawPayload);
      deblicatePayload.event = "select_item";

      delete deblicatePayload.ecommerce.currency;
      delete deblicatePayload.ecommerce.value;

      deblicatePayload.ecommerce['item_list_id'] = rawPayload.ecommerce.items[0].item_list_id;
      deblicatePayload.ecommerce['item_list_name'] = rawPayload.ecommerce.items[0].item_list_name;

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(deblicatePayload);
      console.log('select_item', deblicatePayload);
      window.location.href = redirectURL;
    } catch (error) {
      window.location.href = redirectURL;
    }
  });

  document.addEventListener('click', (e) => {
    const aEL = e.target.closest('.cart-item__link, .cart-item__name');
    if (!aEL || !aEL.href) return;

    const row = aEL.closest('.cart-item');
    const payloadInput = row?.querySelector('.gtmPayload');
    if (!payloadInput) return;

    const openInNewTab = e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1 || aEL.target === '_blank';

    if (!openInNewTab) e.preventDefault();
    const redirectURL = aEL.href;
    try {
      const payload = JSON.parse(payloadInput.value);
      payload.event = 'select_item';

      delete payload.ecommerce.currency;
      delete payload.ecommerce.value;

      const item = payload.ecommerce.items[0];
      item.item_list_id = '';
      item.item_list_name = '';
      payload.ecommerce['item_list_id'] = '';
      payload.ecommerce['item_list_name'] = '';

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(payload);
    } catch (error) {}
    if (!openInNewTab) window.location.href = redirectURL;
  });
});

function gtmMainCartEvent(gtmPayloadValue, eventName, quantityDiff) {
  if (!gtmPayloadValue) return;

  let gtmPayload = JSON.parse(gtmPayloadValue);
  gtmPayload.event = eventName;

  if (quantityDiff != null) {
    const item = gtmPayload.ecommerce.items[0];
    item.quantity = quantityDiff;
    gtmPayload.ecommerce.value = (parseFloat(item.price) * quantityDiff).toFixed(2);
  }

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push(gtmPayload);
}

window.gtmMainCartEvent = gtmMainCartEvent;


function gtm_removeFromCart(e, quantityDiff) {
  let gtmPayload = e.closest('li')?.querySelector('.gtmPayload')?.value;

  if (gtmPayload) {
    gtmPayload = JSON.parse(gtmPayload);
    gtmPayload.event = 'remove_from_cart';

    if (quantityDiff != null) {
      gtmPayload.ecommerce.items[0].quantity = quantityDiff;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_removeFromCart = gtm_removeFromCart;

function gtm_addToCart(e, quantityDiff) {
  let gtmPayload = e.closest('li')?.querySelector('.gtmPayload')?.value;

  if (gtmPayload) {
    gtmPayload = JSON.parse(gtmPayload);
    gtmPayload.event = 'add_to_cart';

    if (quantityDiff != null) {
      gtmPayload.ecommerce.items[0].quantity = quantityDiff;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_addToCart = gtm_addToCart;


async function pushViewCartEvent() {
  try {
    const response = await fetch(`${window.Shopify.routes.root}?sections=main-cart-items`);
    const sections = await response.json();

    const html = new DOMParser().parseFromString(
      sections['main-cart-items'],
      'text/html'
    );

    const payloadInput = html.querySelector('.gtmPayload.main-cart-gtm');

    if (!payloadInput) return;

    const gtmPayload = JSON.parse(payloadInput.value);

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  } catch (error) {
    console.error('Failed to push view_cart event:', error);
  }
}

window.pushViewCartEvent = pushViewCartEvent;

function gtmRefreshViewItemList() {
  const mainGrid = document.querySelector('.main-product-grid');
  if (!mainGrid || typeof window.gtmLoadmore !== 'function') return;

  const cards = Array.from(mainGrid.querySelectorAll('.product-card-wrapper'));
  if (!cards.length) return;

  window.gtmLoadmore(cards, 1, cards.length);
}

window.gtmRefreshViewItemList = gtmRefreshViewItemList;

function gtmPushViewItemList(container, sectionId, sectionName) {
  if (!container || !sectionName) return;

  const items = Array.from(container.querySelectorAll('.gtmPayload')).map((input, index) => {
    const item = JSON.parse(input.value).ecommerce.items[0];
    item.index = index;
    return item;
  });
  if (!items.length) return;

  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id: sectionId,
      item_list_name: sectionName,
      items,
    },
  });
}

window.gtmPushViewItemList = gtmPushViewItemList;
